module.exports = {"publicKey":"BAjYLZ6yJvPfuQq0-dFyauSbzW6pcdpkwbusahPhbOv0Rdy1L8nZjW3906G1jBd6UxP1Leh_ASzMxPjjs4vnR6A","privateKey":"D7yb0_v2bxQCh-oRQw6e-MVtwGQNWMm2GzgHITj3vEk"}


//////////////////
// WEBPACK FOOTER
// ./src/notifications/vapid.json
// module id = 307
// module chunks = 1